export {
  default,
  TableCell,
  TableHeader,
  TableHeaders,
  TableRow,
} from './Table';
